import { TaxonomySystem } from './types';

export const MEDICAL_TAXONOMY: TaxonomySystem[] = [
  {
    name: 'Skeletal System',
    regions: [
      { name: 'Cranium & Face', focusAreas: ['Skull (Whole)', 'Frontal Bone', 'Mandible', 'Orbit', 'Zygomatic Arch', 'Temporomandibular Joint', 'Base of Skull', 'Nasal Bone'] },
      { name: 'Spine', focusAreas: ['Vertebral Column (Whole)', 'Cervical Vertebrae (C1-C7)', 'Atlas (C1)', 'Axis (C2)', 'Thoracic Vertebrae', 'Lumbar Vertebrae', 'Sacrum', 'Coccyx', 'Intervertebral Disc'] },
      { name: 'Thorax', focusAreas: ['Rib Cage', 'Sternum', 'Clavicle', 'Scapula', 'Costal Cartilage'] },
      { name: 'Pelvis', focusAreas: ['Pelvic Girdle', 'Ilium', 'Ischium', 'Pubis', 'Hip Joint', 'Acetabulum', 'Sacroiliac Joint'] },
      { name: 'Upper Limb', focusAreas: ['Humerus', 'Radius', 'Ulna', 'Carpals', 'Metacarpals', 'Phalanges', 'Shoulder Joint', 'Elbow Joint', 'Wrist Joint'] },
      { name: 'Lower Limb', focusAreas: ['Femur', 'Tibia', 'Fibula', 'Patella', 'Tarsals', 'Metatarsals', 'Phalanges', 'Knee Joint', 'Ankle Joint', 'Calcaneus'] },
    ]
  },
  {
    name: 'Muscular System',
    regions: [
      { name: 'Head & Neck', focusAreas: ['Facial Muscles', 'Sternocleidomastoid', 'Masseter', 'Temporalis', 'Trapezius (Upper)', 'Platysma'] },
      { name: 'Torso (Anterior)', focusAreas: ['Pectoralis Major', 'Pectoralis Minor', 'Rectus Abdominis', 'External Oblique', 'Serratus Anterior', 'Diaphragm'] },
      { name: 'Torso (Posterior)', focusAreas: ['Latissimus Dorsi', 'Trapezius', 'Erector Spinae', 'Rhomboids', 'Infraspinatus', 'Supraspinatus'] },
      { name: 'Upper Limb', focusAreas: ['Deltoid', 'Biceps Brachii', 'Triceps Brachii', 'Brachioradialis', 'Flexor Carpi Group', 'Extensor Carpi Group', 'Thenar Eminence'] },
      { name: 'Lower Limb', focusAreas: ['Quadriceps Femoris', 'Hamstrings', 'Gluteus Maximus', 'Gluteus Medius', 'Gastrocnemius', 'Soleus', 'Tibialis Anterior', 'Achilles Tendon'] },
    ]
  },
  {
    name: 'Cardiovascular System',
    regions: [
      { name: 'Heart', focusAreas: ['Heart (External)', 'Heart (Internal Cross-section)', 'Left Ventricle', 'Right Ventricle', 'Left Atrium', 'Right Atrium', 'Mitral Valve', 'Tricuspid Valve', 'Aortic Valve', 'Pulmonary Valve', 'Coronary Arteries'] },
      { name: 'Great Vessels', focusAreas: ['Aorta (Ascending)', 'Aortic Arch', 'Abdominal Aorta', 'Superior Vena Cava', 'Inferior Vena Cava', 'Pulmonary Artery', 'Pulmonary Vein'] },
      { name: 'Head & Neck Vasculature', focusAreas: ['Carotid Artery', 'Internal Jugular Vein', 'Circle of Willis', 'Vertebral Artery'] },
      { name: 'Abdominal Vasculature', focusAreas: ['Renal Artery', 'Celiac Trunk', 'Superior Mesenteric Artery', 'Hepatic Portal Vein'] },
      { name: 'Peripheral Vasculature', focusAreas: ['Femoral Artery', 'Popliteal Artery', 'Radial Artery', 'Ulnar Artery', 'Brachial Artery', 'Great Saphenous Vein'] },
    ]
  },
  {
    name: 'Nervous System',
    regions: [
      { name: 'Brain (Central)', focusAreas: ['Brain (Whole)', 'Cerebrum', 'Frontal Lobe', 'Temporal Lobe', 'Parietal Lobe', 'Occipital Lobe', 'Cerebellum', 'Brainstem', 'Corpus Callosum', 'Thalamus', 'Hypothalamus', 'Basal Ganglia', 'Hippocampus', 'Amygdala'] },
      { name: 'Spinal Cord', focusAreas: ['Spinal Cord (Cross-section)', 'Cervical Cord', 'Thoracic Cord', 'Lumbar Cord', 'Cauda Equina'] },
      { name: 'Cranial Nerves', focusAreas: ['Olfactory Nerve (I)', 'Optic Nerve (II)', 'Oculomotor Nerve (III)', 'Trigeminal Nerve (V)', 'Facial Nerve (VII)', 'Vagus Nerve (X)'] },
      { name: 'Peripheral Nerves', focusAreas: ['Brachial Plexus', 'Sciatic Nerve', 'Median Nerve', 'Ulnar Nerve', 'Radial Nerve', 'Femoral Nerve', 'Peroneal Nerve'] },
    ]
  },
  {
    name: 'Respiratory System',
    regions: [
      { name: 'Upper Respiratory Tract', focusAreas: ['Nasal Cavity', 'Pharynx', 'Larynx', 'Epiglottis', 'Vocal Cords'] },
      { name: 'Lower Respiratory Tract', focusAreas: ['Trachea', 'Carina', 'Primary Bronchi', 'Bronchioles', 'Alveoli (Micro)'] },
      { name: 'Lungs', focusAreas: ['Lungs (Whole)', 'Right Lung (Lobes)', 'Left Lung (Lobes)', 'Pleura', 'Diaphragm'] },
    ]
  },
  {
    name: 'Digestive System',
    regions: [
      { name: 'Oral & Esophageal', focusAreas: ['Oral Cavity', 'Tongue', 'Salivary Glands', 'Esophagus', 'Lower Esophageal Sphincter'] },
      { name: 'Stomach & Duodenum', focusAreas: ['Stomach (External)', 'Stomach (Internal Rugae)', 'Pyloric Sphincter', 'Duodenum'] },
      { name: 'Intestines', focusAreas: ['Small Intestine (Whole)', 'Jejunum', 'Ileum', 'Large Intestine (Colon)', 'Cecum', 'Appendix', 'Sigmoid Colon', 'Rectum'] },
      { name: 'Hepatobiliary', focusAreas: ['Liver', 'Gallbladder', 'Biliary Tree', 'Common Bile Duct', 'Pancreas', 'Pancreatic Duct'] },
    ]
  },
  {
    name: 'Urinary System',
    regions: [
      { name: 'Kidney', focusAreas: ['Kidney (Whole)', 'Kidney (Cross-section)', 'Renal Cortex', 'Renal Medulla', 'Renal Pelvis', 'Nephron (Micro)', 'Glomerulus (Micro)'] },
      { name: 'Urinary Tract', focusAreas: ['Ureter', 'Urinary Bladder', 'Urethra (Male)', 'Urethra (Female)'] },
    ]
  },
  {
    name: 'Reproductive System',
    regions: [
      { name: 'Male Reproductive', focusAreas: ['Testes', 'Epididymis', 'Vas Deferens', 'Prostate Gland', 'Seminal Vesicles', 'Penis (Cross-section)'] },
      { name: 'Female Reproductive', focusAreas: ['Uterus', 'Ovaries', 'Fallopian Tubes', 'Cervix', 'Vagina', 'Mammary Gland'] },
    ]
  },
  {
    name: 'Lymphatic & Immune',
    regions: [
      { name: 'Lymphoid Organs', focusAreas: ['Spleen', 'Thymus', 'Tonsils', 'Bone Marrow'] },
      { name: 'Lymphatic Vessels', focusAreas: ['Thoracic Duct', 'Right Lymphatic Duct', 'Cervical Lymph Nodes', 'Axillary Lymph Nodes', 'Inguinal Lymph Nodes'] },
    ]
  },
  {
    name: 'Endocrine System',
    regions: [
      { name: 'Glands', focusAreas: ['Pituitary Gland', 'Thyroid Gland', 'Parathyroid Glands', 'Adrenal Glands', 'Pineal Gland', 'Islets of Langerhans (Pancreas)'] },
    ]
  },
  {
    name: 'Integumentary System',
    regions: [
      { name: 'Skin Structure', focusAreas: ['Skin Cross-section', 'Epidermis', 'Dermis', 'Subcutaneous Tissue', 'Hair Follicle', 'Sebaceous Gland', 'Sweat Gland', 'Nail Bed'] },
    ]
  },
  {
    name: 'Sensory Organs',
    regions: [
      { name: 'Eye', focusAreas: ['Eye (Cross-section)', 'Retina', 'Cornea', 'Lens', 'Iris & Pupil', 'Optic Nerve Head'] },
      { name: 'Ear', focusAreas: ['Ear (Cross-section)', 'Outer Ear (Pinna)', 'Middle Ear (Ossicles)', 'Inner Ear (Cochlea)', 'Vestibular System'] },
    ]
  }
];

export const PLANES = ['Sagittal', 'Coronal', 'Transverse/Axial', 'Oblique', 'None (3D Default)'];
export const VIEWS = ['Anterior', 'Posterior', 'Lateral (Left)', 'Lateral (Right)', 'Superior', 'Inferior', 'Isometric', 'Endoscopic'];
export const ZOOMS = ['Macro (Histology)', 'Gross Anatomy', 'Full Body', 'Surgical Field', 'Cellular'];

export const STYLES = [
  { label: 'Medical Illustration (Netter-style)', value: 'Netter-style watercolor medical illustration, detailed, matte, educational color palette' },
  { label: 'Gray\'s Anatomy (Engraving)', value: 'Classic 19th-century engraving style, black and white, cross-hatching, line art, high contrast' },
  { label: 'Radiology: MRI (T2)', value: 'T2-weighted MRI scan, grayscale, high contrast fluid, medical imaging' },
  { label: 'Radiology: CT Scan (Bone)', value: 'CT scan slice, bone window, high contrast, medical imaging' },
  { label: 'Radiology: X-Ray', value: 'Plain film radiograph, inverted grayscale, skeletal focus' },
  { label: '3D Render: Hyper-realistic', value: '8k hyper-realistic 3D render, physically based rendering (PBR), subsurface scattering, biological textures, wet surfaces' },
  { label: '3D Render: Plastic Model', value: 'Clean anatomical plastic model, color coded parts, smooth matte finish, museum quality' },
  { label: '3D Render: Ghost/Transparent', value: 'Semi-transparent anatomical view, internal structures visible, glowing edges, holographic style' },
  { label: 'Sketch: Blackboard', value: 'Medical diagram drawn on blackboard with white chalk, rough lines, academic' },
  { label: 'Sketch: Pencil', value: 'Graphite pencil sketch on paper, shading, artistic anatomical study' },
  { label: 'Vector: Flat Design', value: 'Minimalist vector art, flat colors, clean lines, icon style, simplified' },
];

export const LIGHTING = ['Studio Neutral (Textbook)', 'Dramatic (Cover Art)', 'Clinical (Operating Room)', 'Volumetric (Cinematic)', 'Rembrandt', 'Dark Field'];
export const BACKGROUNDS = ['Pure White', 'Transparent (Alpha)', 'Dark Grey', 'Operating Theatre', 'Blue Gradient', 'Black'];

export const DISCLAIMER_TEXT = "AI Generated images are for educational and illustrative purposes only and should not be used for primary diagnosis or surgical planning without verification.";